"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Cta() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  return <section className="bg-[#EEEEEE] px-3 sm:px-4 ![padding-top:144px] ![padding-bottom:144px]">
  <div className="max-w-7xl mx-auto">
    <div className="rounded-[1rem] bg-[#FF6F61] p-8 sm:p-12 md:p-16 flex flex-col sm:flex-row sm:items-end sm:justify-between gap-8 min-h-[250px] sm:min-h-[300px] transition-all duration-300 hover:shadow-2xl justify-end">
      <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-white leading-tight max-w-2xl">
        Neugierig?<br />Ab 40€ pro Tag.
      </h2>
      <Link to="/preise" className="w-full sm:w-auto">
        <Button size="lg" className="h-14 w-full sm:w-auto rounded-full bg-white/20 backdrop-blur-sm border border-white/30 hover:bg-white/30 text-white text-base font-semibold transition-all duration-300 hover:-translate-y-0.5 flex-shrink-0" style={{
            paddingLeft: '40px',
            paddingRight: '40px'
          }}>
          Jetzt Preise ansehen
        </Button>
      </Link>
    </div>
  </div>
</section>;
}